var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-header-logo"},[_c('ElementLogo',{attrs:{"reverse":!!_vm.themeObj.style}},[_c('div',{staticClass:"logo-wrap"},[(_vm.collapsed)?_c('a',{staticClass:"logo-mini"}):_c('a',{staticClass:"logo"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }